{
  "ontology": "Datenmodell",
  "sources": "Dokumente",
  "threads": "Durchläufe",
  "workflows": "Prozessschemata"
}
